module.exports = __webpack_public_path__ + "img/hero.06c51d6b.webp";